// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import utils from "../../../../share/util/utils";
import session from '../../../../share/session';
import cstmTable from '../../../../share/components/vue/PaginationTable';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';

// 検索条件
const SEARCH_YEAR_RANGE = 1;
const SEARCH_MONTH_RANGE = 12;

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  DEL_CHK: 'delChk',
  DELETE: 'delete',
  SUCCESS: 'success',
  CONFIRMATION: 'confirmation',
  FAILURE: 'failure',
  FAILED: 'failed'
};

export default {
  name: 'requirement012',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      selectedDestination: false,
      /** APIから取得した機能リストを常に保持しておく */
      originalDataList: [],
      /** 画面に表示する為の機能リスト */
      filteredDataList: [],
      /** 選択中のコード */
      selectedData: {},
      /** 保存日時（年）フィルター選択リスト */
      searchYearOptions: [''],
      /** 保存日時（月）フィルター選択リスト */
      searchMonthOptions: [''],
      /** フィルター用テキスト */
      selectedYear: '',
      selectedMonth: '',
      filterRegistrant: '',
      filterDataId: '',
      /** 読み出しデータ */
      dataIdReadData: '',
      systemId: '',
      isModalSize: "xl",
      /** 削除選択されたデータのリスト */
      selectedItems: [],
      selectedItem: undefined,
      readType: '',
      writeType: '',
      exitType: '',
      isFirst: true,
      // ダイアログフラグ
      modal_requirement_012: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    'cstm-table': cstmTable,
  },

  computed: {
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.FAILURE:
        case PHASE.DELETE:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.START:
        case PHASE.CONFIRMATION:
        case PHASE.DEL_CHK:
        default:
          return 'secondary';
      }
    },

    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.cache.vehicleInfo
    }),

    systemTableColumns() {
      return [
        { name: 'registered_at', label: this.i18nWsKey + '.label_table_registration_date' },
        { name: 'vin', label: 'message.header_measured_data_list_vin' },
        { name: 'registered_by', label: this.i18nWsKey + '.label_filter_registrants' },
        { name: 'data_id', label: this.i18nWsKey + '.label_filter_data_id' },
        { name: 'delete', label: this.i18nWsKey + '.label_data_delete', useButton: true },
      ];
    },
  },

  methods: {
    /** 初期化処理 */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.wsIdToType();
      this.modal_requirement_012 = true;
    },

    // 呼び出された機能別にtypeを設定するメソッド
    wsIdToType() {
      switch (this.workSupportId) {
        case 3701:
        case 3801:
          this.readType = 'read-ws012';
          this.writeType = 'write-ws012';
          this.exitType = 'exit-ws012';
          break;
        default:
          this.readType = 'read';
          this.writeType = 'write';
          this.exitType = 'exit';
          break;
      }
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_012 = false;
    },

    ...mapActions('auth', ['logout', 'resetSession']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // 初期の検索条件の設定（現在の年、月）
      const currentYear = new Date().getFullYear();
      // 空白(全年検索用)+今年+去年を選択できるような選択肢配列を作成
      this.searchYearOptions = [''].concat([...Array(SEARCH_YEAR_RANGE + 1)].map((_, i) => String(currentYear - i)));
      // 空白(全月検索用)+1月-12月を選択できるような選択肢配列を作成
      this.searchMonthOptions = [''].concat([...Array(SEARCH_MONTH_RANGE)].map((_, i) => String(i + 1)));
      this.updateTable();
    },

    /**
     * 選択したデータの読み出しデータ
     */
    clickRow: async function (selected) {
      this.selectedData = selected;
      this.setHighLight();
      this.selectedDestination = true;

      // ユーザが選択したデータの読み出しデータを表示する
      const filteredItem = this.filteredDataList.find(item => item.data_id === this.selectedData.data_id.toString());

      if (filteredItem) {
        const showDat = await individualWorkSupportUtil.getReadOutData(this, this.systemId, filteredItem);
        this.dataIdReadData = showDat;
      }
    },

    /**
     * 行選択削除
     * @param {object} selected 選択した行の情報
     */
    deleteRow(selected) {
      // 削除確認ダイアログを表示
      this.isModalSize = "md";
      this.selectedItem = selected;
      this.phase = PHASE.DEL_CHK;
    },

    /**
     * 一覧からデータを削除（非表示）
     * @param {*} flg 削除確認画面でOKボタン押下：true, キャンセルボタン押下：false
     */
    async setData(flg) {
      try {
        this.isLoading = true;
        // カスタムテーブルの描画の為sleep処理を実施
        await utils.sleep(1000);
        if (flg) {
          // 見た目上、選択行を削除
          this.filteredDataList = this.filteredDataList.filter(item => !this.selectedItems.includes(item.data_id));
          // OKボタン押下不可
          this.selectedDestination = false;
        } else {
          this.filteredDataList = this.filteredDataList.filter(item => {
            // 翻訳後の名称を大文字・小文字区別なくフィルターする
            // 削除対象は表示しない
            const yearFilter = this.selectedYear.toLowerCase();
            const monthFilter = this.selectedMonth.toLowerCase();
            const itemYear = new Date(item.registered_at).getFullYear().toString();
            const itemMonth = new Date(item.registered_at).getMonth() + 1;

            return (
              (yearFilter === "" || itemYear.includes(yearFilter)) &&
              (monthFilter === "" || itemMonth === Number(monthFilter)) &&
              item.registered_by.toLowerCase().includes(this.filterRegistrant.toLowerCase()) &&
              item.data_id.toLowerCase().includes(this.filterDataId.toLowerCase()) &&
              !this.selectedItems.includes(item.data_id)
            );
          });
        }
        //フィルター、読み出しデータを初期化
        this.dataIdReadData = '';
        this.filterRegistrant = '';
        this.filterDataId = '';
      } finally {
        this.isLoading = false;
      }
    },

    delOk() {
      this.isModalSize = "xl";
      // 削除対象のdata_idを配列化
      this.selectedItems.push(this.selectedItem.data_id);
      this.phase = PHASE.START;
      this.setData(true);
    },

    delCancel() {
      this.isModalSize = "xl";
      this.phase = PHASE.START;
      this.setData(false);
    },

    /**
     * 選択している機能のハイライト設定
     */
    setHighLight() {
      this.filteredDataList.forEach(item => {
        if (item === this.selectedData) {
          item.fieldSpec = {};
          item.fieldSpec.registered_at = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.vin = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.registered_by = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.data_id = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.delete = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.locale_key = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
            // OKボタン押下不可
            this.selectedDestination = false;
            // 読み出しデータを初期化
            this.dataIdReadData = '';
          }
        }
      });
    },

    /**
     * 選択状態を解除し、フィルターの文字列に応じてリストをフィルターする
     */
    searchFilter() {
      this.selectedData = {};
      this.setHighLight();

      this.filteredDataList = this.originalDataList.filter(item => {
        // 翻訳後の名称を大文字・小文字区別なくフィルターする
        // 削除対象は表示しない
        const yearFilter = this.selectedYear.toLowerCase();
        const monthFilter = this.selectedMonth.toLowerCase();
        const itemYear = new Date(item.registered_at).getFullYear().toString();
        const itemMonth = new Date(item.registered_at).getMonth() + 1;

        return (
          (yearFilter === "" || itemYear.includes(yearFilter)) &&
          (monthFilter === "" || itemMonth === Number(monthFilter)) &&
          item.registered_by.toLowerCase().includes(this.filterRegistrant.toLowerCase()) &&
          item.data_id.toLowerCase().includes(this.filterDataId.toLowerCase()) &&
          !this.selectedItems.includes(item.data_id)
        );
      });
    },

    /**
     * テーブル情報の更新を行う
     */
    async updateTable() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: this.readType
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        let cnv_registered_at = '';

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：一覧データ取得処理を行う
              this.filteredDataList = response.data.user_data.read_data;

              // registered_at(unixtime)をYYYY/MM/DD HH:mm:ss形式に変換
              this.filteredDataList.forEach(item => {
                cnv_registered_at = utils.timeConverter(item.registered_at);
                item.registered_at = cnv_registered_at;
                item.buttonVisible = true;
              });

              this.originalDataList = this.filteredDataList;
              this.searchFilter();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 実行処理 */
    async executeProcess() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        //実行処理（バックエンドAPI）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: this.writeType,
            data_id: this.selectedData.data_id.toString(),
            is_first : this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          this.isModalSize = "md";

          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 書込みに成功したデータを削除対象のデータとして追加
              this.selectedItems.push(this.selectedData.data_id);

              // 正常終了：書き込み成功画面表示
              this.phase = PHASE.SUCCESS;
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              switch (response.data.async_code) {
                case error.WSP_DB_READ_DATA_INFO_NOT_FOUND:
                  // ：データ削除済みエラー画面表示
                  this.phase = PHASE.DELETE;
                  break;
                case error.WSP_WRITE_VARIANT_MODE_OFF_ERROR:
                  // ws.37,ws.38のエラー
                  this.showUnexpectedError();
                  break;
                default:
                  // 異常終了：再書込み確認画面表示
                  this.phase = PHASE.CONFIRMATION;
                  return;
              }
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /** 待機画面へ戻る */
    backStart() {
      this.isModalSize = "xl";
      this.phase = PHASE.START;
      this.updateTable();
    },

    /** 書込み失敗 */
    async failureProcess() {
      // 書込み失敗画面表示
      this.phase = PHASE.FAILURE;
      return;
    },

    /**
     * Exit処理
     * 削除選択したデータ及び保存日時から30日以上経過したデータを削除
     */
    async exit() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // Exit処理（バックエンドAPI）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: this.exitType,
            data_id: this.selectedItems,
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常、異常に関わらず、処理を終了
          this.closeWizard();
          return;
        } else {
          // responseが空の場合、処理を終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result バリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** その他のエラー */
    showUnexpectedError() {
      this.isModalSize = "md";
      // 異常終了：汎用エラーを表示
      this.phase = PHASE.FAILED;
    },
  },

  async mounted() {
    this.init();
    this.mountedLogic();
  },
};